<template>
   <div class="timeline__race-outer"
       :class="{'is-popup': popupActive}"
       @click="gotoRace"
       @mouseover="popupChange($event)"
       @mouseleave="popupChange($event)"
       v-on:wheel.stop
       v-on:touchmove.stop
       @touchstart.stop
   >
      <router-link
          :to="{ name: 'Race', params: {'meeting_id': meeting.id, 'race_id': race.id} }"
          class="timeline__race"
          :class="cardClasses"
      >
         <div class="timeline__race__code-mobile" v-if="isMobile">
            {{race.code}}
         </div>
         <div class="timeline__race__header">
            <span class="timeline__race__header__code">{{race.code}}</span> <span class="timeline__race__name" v-if="!isCompact">{{race.name}}</span>
         </div>
         <div class="timeline__race__time" v-if="isCompact">
            {{timeFormatted}}
         </div>
         <div class="timeline__race__content">
            <div class="timeline__race__time" v-if="!isCompact">
               {{aboutTime}}
            </div>
            <!-- isFuture -->
            <div class="timeline__race__content__text" v-if="isFuture && !isCompact">
               {{t('racecard.info.race.type.' + race.type)}} - {{race.distance}}m<br>
               {{race.starters}} partants
            </div>
            <div class="timeline__race__content__text" v-if="/*isFuture &&*/ isCompact">
               <game
                   v-if="isBoosted && statusFlag.length > 0"
                   class="ml-1"
                   :bet="{code: 'booster'}"
                   iconed
                   size="xs"
               />
               <game
                   v-else-if="onePremium"
                   class="ml-1"
                   iconed
                   no-booster
                   size="xs"
                   :bet="onePremium"
               />
            </div>
            <!-- isWaiting -->
            <b v-if="isWaiting && !isCompact">
               {{timeLeftFormatted}}
            </b>
            <!--isFinished-->
            <div class="timeline__race__content__combination" v-if="isFinished  && !isCompact && race.result && isOfficial">
               {{race.result}}
            </div>


            <div class="timeline__race__status">
               <game
                   v-if="isBoosted && 0 === statusFlag.length"
                   class="mb-1"
                   :bet="{code: 'booster'}"
                   iconed
                   size="xs"
               />
               <span class="icon" :class="statusFlag"></span>
            </div>
            <div class="timeline__race__info__trigger" v-if="!isMobile" @click.stop.prevent="popupChange($event)"><span class="icon icon--info"></span></div>
         </div>
      </router-link>

      <!-- Info popup -->
      <div class="timeline__race__info" @click.stop.prevent :class="{ 'is-open': popupActive}">
         <div class="timeline__race__info__header">
            <b>{{meeting.code+race.code}} - {{race.name}}</b>
            <div class="timeline__race__info__header__text">
               {{race.info}}
            </div>
         </div>
         <div class="timeline__race__info__header" v-if="isFinished && race.result">
				<span v-if="isOfficial">
					{{race.result}}
				</span>
         </div>
         <div class="timeline__race__info__content">

            <game class="d-inline-block"
                iconed
                size="xs"
                :bet="bet"
                :key="bet.code"
                v-for="bet in sortBettype(race.bets)"

            />
         </div>
      </div>
   </div>
</template>

<script>
import Popper from 'popper.js';
import moment from 'moment-timezone';
export default {
   name: "timeline-card",
   props: ['race', 'currentTime', 'size', 'meeting', 'outerCLick', 'trackPos', 'activePopup'],
   data(){
      return {
         waitingPeriod: (3*60*1000), // 3 minutes in milliseconds
         popper: null,
         popupActive: false
      }
   },
   beforeDestroy(){
      if(this.popper !== null){
         this.popper.destroy();
      }
   },
   computed:{
      timeLeft(){
         //Calc diff between current time and race start time
         if(this.race.status === 'CLOSED' || this.race.status === 'CANCELED'){
            return -1;
         }
         return (moment(this.race.time)).valueOf() - this.currentTime.valueOf();
      },
      timeLeftFormatted(){
         let x = moment(this.race.time);
         let y = moment(this.currentTime);
         let duration = moment.duration(x.diff(y));

         if (duration._data && duration._milliseconds >= 0 ) {
            return duration._data.minutes + ':' + duration._data.seconds;
         } else {
            return '00:00';
         }
      },

      timeFormatted(){
         return moment(this.race.time).format('H[h]mm');
      },
      aboutTime(){
         let text = '';

         if(this.isFuture){
            text = this.timeFormatted;
         }else if(this.isWaiting){
            text = this.t('timeline.race.card.status.depart');
         }else{
            text = this.t('timeline.race.card.status.'+this.race.status);
         }


         return text;
      },

      isWaiting(){

         let started = this.race.start_time !== null ? moment(this.race.start_time).valueOf() : null;

         //Client want to mark it waiting till it don't change status, so we would not block negative difference
         let time = (/*this.timeLeft >= 0 ||*/ !started || started > this.currentTime) && (this.timeLeft<= this.waitingPeriod);


         return time && this.race.status === 'OPEN';
      },
      isFinished(){
         return this.race.status === 'FINISHED' ||	this.race.status === 'OFFICIAL';
      },
      isOfficial(){
         return this.race.status === 'OFFICIAL';
      },
      isFuture(){
         return !this.isWaiting && this.race.status === 'OPEN';
      },
      isCompact(){
         return this.locSize === 'compact'
      },

      isBoosted(){
         let booster = false;
         for(let bettype of this.race.bets){

            if(null !== bettype.booster  && !isNaN(bettype.booster)  ){
               booster = true;
               break;
            }
         }
         return booster;
      },

      statusFlag(){
         let status = [];
         switch (this.race.status) {
            case 'CLOSED':
               status.push('icon--close');
               break;
            case 'FINISHED':
               status.push('icon--flag');
               break;
            case 'OFFICIAL':
               status.push('icon--flag');
               break;
            case 'RUNNING':
               status.push('icon--loop');
               break;
            case 'OPEN':
               if(this.isWaiting){
                  status.push('icon--chrono');
               }
               break;
         }

         return status;
      },
      locSize(){
         return this.size;
      },
      cardClasses(){

         return {
            'is-running': this.race.status === 'RUNNING',
            'is-waiting': this.isWaiting,
            'is-future': this.isFuture,
            'is-ended': this.isFinished || this.race.status === 'CLOSED',
            'timeline__race--large': this.locSize === 'detailed'
         }
      },
      popupId(){
         return this.activePopup;
      },
      onePremium(){



         let f = this.race.bets.find((el)=> el.code === 'Quinte+');

         //If found Quinte+, then show it, otherwise search for other premium bet
         if(f){
            return f;
         }

         return this.race.bets.find((el)=> el.premium);

      }
   },
   watch:{
      popupId(val){
         if(val === this.race.id){
            this.togglePopup(true);
         }else{
            this.togglePopup(false);
         }

      },
      trackPos(){
         this.togglePopup(false);
      }
   },
   mounted(){

   },
   methods:{
      gotoRace(){
         this.$router.push({ name: 'Race', params: {'meeting_id': this.meeting.id, 'race_id': this.race.id} })
      },
      popupChange(event){
         if(event.type === 'mouseleave'){
            this.$emit('popupChange', null)
         }else if(event.type === 'mouseover'){
            this.$emit('popupChange', this.race.id)
         }else{
            this.$emit('popupChange', this.race.id)
         }



      },
      togglePopup(state){
         if(!this.isMobile){
            this.popupActive = state;


            this.$nextTick(()=>{

               if(state){
                  let ref = this.$el.querySelector('.timeline__race');
                  let tgt = this.$el.querySelector('.timeline__race__info');
                  this.popper = new Popper(ref, tgt, {
                     positionFixed: true,
                     placement: 'bottom'
                  })
               }else if(this.popper !== null){
                  this.popper.destroy();
               }
            })
         }



      }
   }
}
</script>

<style scoped>

</style>
